
/**
 * Checks if the object that is passed in is null or undefined
 * @param {Object} object - Any object
 * @returns {boolean} The boolean indicating whether object is null or undefined
 */
export const isNullOrUndefined = (object) => {
    return object === undefined || object === null
}

/**
 * Gets the month difference between two dates 
 * @param {string} oldStartDate - String date of first date you want to compare
 * @param {string} newStartDate - String date of second date you want to compare
 * @returns {number} The number of periods between the two input dates
 */
export const periodsBetween = (oldStartDate, newStartDate) => {
    let oldDate = new Date(oldStartDate)
    let newDate = new Date(newStartDate) 
    return ((newDate.getFullYear()-oldDate.getFullYear()) * 12) + newDate.getMonth() - oldDate.getMonth()
}